import React from 'react';
import {
  createTheming,
  createUseStyles as createUseStylesNative
} from 'react-jss';

const context = React.createContext({});
const theming = createTheming(context);

export const createUseStyles = (styles) =>
  createUseStylesNative(styles, { theming });

export const { ThemeProvider, useTheme } = theming;

export default theming;
